module.exports = __webpack_public_path__ + "media/images/cliparts/3 people-392373232fb1a7d3e42a11877dc9aeac.svg";